//
// Site Header
// --------------------------------------------------
// Functionality for mobile navigation toggling

const _debounce = require('lodash.debounce');
const _throttle = require('lodash.throttle');

import { PageUtils } from "./helpers/page-utils";

function unlockBody() {
    PageUtils.bodyLockToggleOff();
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    if (scrollCta) {
        scrollCta.classList.remove('hidden');
    }
}

function lockBody() {
    PageUtils.bodyLockToggleOn();
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    if (scrollCta) {
        scrollCta.classList.add('hidden');
    }
}

window.addEventListener('load', () => {
    const docBody = document.body;
    const siteHeader = document.getElementById('siteHeader');
    const offCanvasMenuMobile = document.getElementById('offCanvasMenuMobile');
    const offCanvasMenuMobileAccordions = offCanvasMenuMobile?.querySelectorAll('[data-tw-toggle-container]')
    const offCanvasMenuDesktop = document.getElementById('offCanvasMenuDesktop');
    const menuToggleMobile = document.getElementById('menuToggleMobile');
    const navBackdropMobile = document.getElementById('navBackdropMobile');
    let scrollLimit = 500;
    let navOpenScrollPosY = window.scrollY;

    // id for below is retrieved from animated-hamburger.svg
    const hamburger = document.getElementById('ek0RzW3Va4r1');
    // https://www.svgator.com/help/getting-started/svgator-player-js-api
    // ^ related to below svgatorPlayer controls
    const player = hamburger ? hamburger.svgatorPlayer : {};

    function toggleHamburger() {
        if (hamburger) {
            if (player.play) {
                if (player.hasEnded || player.isPlaying) {
                    player.reverse();
                } else {
                    player.play();
                }
            }
        }
    }

    function closeHamburger() {
        if (hamburger) {
            if (player.play) {
                player.reverse();
            }
        }
    }

    if (offCanvasMenuMobile && menuToggleMobile) {
        menuToggleMobile.addEventListener('click', () => {
            // updates navOpenScrollPos on nav open so scroll limit can compare with the current open position
            navOpenScrollPosY = window.scrollY;

            if (window.matchMedia('(min-width: 1024px)').matches) {
                // desktop functions
                if (siteHeader) {
                    if (siteHeader.dataset.dropdown === 'false') {
                        siteHeader.dataset.dropdown = 'true';
                    } else {
                        siteHeader.dataset.dropdown = 'false';
                        closeDesktopNav()
                    }
                    toggleHamburger();
                    startListening();
                }
            } else {
                // mobile functions

                if (siteHeader) {
                    if (siteHeader.dataset.open === 'false') {
                        siteHeader.dataset.open = 'true';

                        if (navBackdropMobile) {
                            navBackdropMobile.dataset.open = 'true';
                        }
                        lockBody();
                    }
                    else {
                        siteHeader.dataset.open = 'false';
                        siteHeader.dataset.dropdown = 'false';

                        if (navBackdropMobile) {
                            navBackdropMobile.dataset.open = 'false';
                        }
                        unlockBody();

                        for (const offCanvasMenuMobileAccordion of offCanvasMenuMobileAccordions) {
                            offCanvasMenuMobileAccordion.dataset.open = 'false';
                        }
                    }
                }

                toggleHamburger();

                scrollLimit = (offCanvasMenuMobile.offsetHeight / 3) * 2;
                startListening();
            }
        });
    }

    if (offCanvasMenuDesktop) {
        initDesktopDrawerListeners();
    }

    function closeMobileNav() {
        if (siteHeader.dataset.open === 'true') {
            unlockBody();
            siteHeader.dataset.open = 'false';

            if (navBackdropMobile) {
                navBackdropMobile.dataset.open = 'false';
            }
            closeHamburger();

            for (const offCanvasMenuMobileAccordion of offCanvasMenuMobileAccordions) {
                offCanvasMenuMobileAccordion.dataset.open = 'false';
            }
        }
    }

    function closeDesktopNav() {
        if (siteHeader.dataset.dropdown === 'true') {
            siteHeader.dataset.dropdown = 'false';
            closeHamburger();
        }

        if (offCanvasMenuDesktop) {
            offCanvasMenuDesktop.dataset.secondaryDrawerOpen = 'false';
            offCanvasMenuDesktop.dataset.tertiaryDrawerOpen = 'false';

            offCanvasMenuDesktop.querySelectorAll('[data-tertiary-drawer],[data-secondary-drawer]').forEach(drawer => {
                drawer.dataset.visible = 'false';
            });

            const openButtons = offCanvasMenuDesktop.querySelectorAll('[data-open-secondary-drawer],[data-open-tertiary-drawer]');
            for (const openButton of openButtons) {
                openButton.dataset.open = 'false';
            }
        }
    }

    // closes open menus and resets nav to default state
    function closeAllNavs() {
        closeMobileNav();
        closeDesktopNav();
    }

    function startListening() {
        window.addEventListener('click', clickListener);
        window.addEventListener('resize', resizeListener);
        window.addEventListener('scroll', scrollListener);
    }

    function stopListening() {
        window.removeEventListener('click', clickListener);
        window.removeEventListener('resize', resizeListener);
        window.removeEventListener('scroll', scrollListener);
    }

    // Throttle for resize listener to close open menus on page resize
    const closeNavResizeThrottle = _throttle(resizeCloseNav, 50, {leading: true, trailing: true});

    function resizeCloseNav() {
        let windowSize = window.innerWidth;
        setTimeout(() => {
            if (windowSize !== window.innerWidth) {
                closeAllNavs();
                stopListening();
            }
        }, 50);
    }


    // Debounce for click listener to close open menus if click is not inside menu
    const closeNavClickDebounce = _debounce(clickOutsideCloseNav, 50, {leading: true, trailing: true});

    function clickOutsideCloseNav() {
        if (!document.getElementById('siteHeader').contains(event.target)) {
            closeAllNavs();
            stopListening();
        }
    }


    // Throttle for scroll listener to close open menus if scroll exceeded scroll limit
    const closeNavScrollThrottle = _throttle(scrolledPastLimit, 50, {leading: true, trailing: true});

    function scrolledPastLimit() {
        if (siteHeader.dataset.open === 'false') {
            if (window.scrollY >= (scrollLimit + navOpenScrollPosY) || window.scrollY <= (navOpenScrollPosY - scrollLimit)) {
                closeAllNavs();
                stopListening();
            }
        }
    }

    const clickListener = () => {
        closeNavClickDebounce(event);
    };

    const resizeListener = () => {
        closeNavResizeThrottle();
    };

    const scrollListener = () => {
        closeNavScrollThrottle();
    };

    // Throttle for scroll listener to adjust nav position based on scroll
    const throttleNavScrollCheck =  _throttle(navScrollCheck, 50, {leading: true, trailing: false});
    window.addEventListener('scroll', throttleNavScrollCheck, {passive: true});

    let scrollPositive = window.scrollY + scrollLimit;
    setTimeout(() => {
        scrollPositive = window.scrollY + scrollLimit;
    }, 100);

    function navScrollCheck() {
        const scrollPos = window.scrollY;

        setTimeout(() => {
            if (scrollPos > window.scrollY) {
                setNavStyles(true);
                scrollPositive = scrollPos + scrollLimit;
            } else if (scrollPos < window.scrollY) {
                if (scrollPositive < scrollPos) {
                    scrollPositive = scrollPos + scrollLimit;
                    setNavStyles(false);
                }
            }
        }, 50);
    }

    // set nav position on load
    setNavStyles(true);

    // set nav pos / styles based on scrolling
    function setNavStyles(negScroll) {
        if (siteHeader && docBody) {
            if (document.body.dataset.lightboxOpen === 'true') return;
            const wasDropdownOpen = siteHeader.dataset.dropdown === 'true';

            if (window.scrollY > scrollLimit && !negScroll) {
                siteHeader.dataset.visible = 'false';
                docBody.dataset.navVisible = 'false';

                if (wasDropdownOpen) {
                    closeDesktopNav();
                }
            }
            else if (window.scrollY > scrollLimit && negScroll) {
                siteHeader.dataset.visible = 'true';
                docBody.dataset.navVisible = 'true';
            }
            else {
                siteHeader.dataset.visible = 'true';
                docBody.dataset.navVisible = 'true';
            }
        }
    }

    // Keeps offcanvas nav hidden for 500ms on page load to mask transitions
    setTimeout(function() {
        document.getElementById('offCanvasMenuMobile')?.removeAttribute('style');
    }, 500);


    function initDesktopDrawerListeners() {
        // Helper function to close all drawers
        function closeAllDrawers() {
            offCanvasMenuDesktop.querySelectorAll('[data-secondary-drawer]').forEach(drawer => {
                drawer.dataset.visible = 'false';
            });

            offCanvasMenuDesktop.querySelectorAll('[data-tertiary-drawer]').forEach(drawer => {
                drawer.dataset.visible = 'false';
            });

            offCanvasMenuDesktop.querySelectorAll('[data-open-secondary-drawer],[data-open-tertiary-drawer]').forEach(btn => {
                btn.dataset.open = 'false';
            });

            offCanvasMenuDesktop.dataset.secondaryDrawerOpen = 'false';
            offCanvasMenuDesktop.dataset.tertiaryDrawerOpen = 'false';
        }

        // Helper function to close tertiary drawers
        function closeTertiaryDrawers(container = offCanvasMenuDesktop) {
            container.querySelectorAll('[data-tertiary-drawer]').forEach(drawer => {
                drawer.dataset.visible = 'false';
            });

            container.querySelectorAll('[data-open-tertiary-drawer]').forEach(btn => {
                btn.dataset.open = 'false';
            });

            offCanvasMenuDesktop.dataset.tertiaryDrawerOpen = 'false';
        }

        // Helper function to open secondary drawer
        function openSecondaryDrawer(drawerIndex) {
            const targetDrawer = offCanvasMenuDesktop.querySelector(`[data-secondary-drawer="${drawerIndex}"]`);
            const targetStatusContainer = offCanvasMenuDesktop.querySelector(`[data-open-secondary-drawer="${drawerIndex}"]`);

            if (targetDrawer && targetStatusContainer) {
                closeAllDrawers();

                // Open this one
                targetDrawer.dataset.visible = 'true';
                targetStatusContainer.dataset.open = 'true';
                offCanvasMenuDesktop.dataset.secondaryDrawerOpen = 'true';
            }
        }

        // Helper function to open tertiary drawer
        function openTertiaryDrawer(drawerIndex, secondaryDrawer) {
            const targetDrawer = secondaryDrawer.querySelector(`[data-tertiary-drawer="${drawerIndex}"]`);
            const targetStatusContainer = secondaryDrawer.querySelector(`[data-open-tertiary-drawer="${drawerIndex}"]`);

            if (targetDrawer && targetStatusContainer) {
                closeTertiaryDrawers();

                // Open this one
                targetDrawer.dataset.visible = 'true';
                targetStatusContainer.dataset.open = 'true';
                offCanvasMenuDesktop.dataset.tertiaryDrawerOpen = 'true';
            }
        }

        // Add hover listeners for secondary drawers
        const secondaryDrawerTriggers = offCanvasMenuDesktop.querySelectorAll('[data-open-secondary-drawer]');
        secondaryDrawerTriggers.forEach(trigger => {
            trigger.addEventListener('mouseenter', () => {
                if (trigger.querySelector('button')) {
                    openSecondaryDrawer(trigger.dataset.openSecondaryDrawer);
                } else {
                    closeAllDrawers();
                }
            });
        });

        // Add hover listeners for tertiary drawers
        const tertiaryDrawerTriggers = offCanvasMenuDesktop.querySelectorAll('[data-open-tertiary-drawer]');
        tertiaryDrawerTriggers.forEach(trigger => {
            trigger.addEventListener('mouseenter', () => {
                const secondaryDrawer = trigger.closest('[data-secondary-drawer]');

                if (trigger.querySelector('button') && secondaryDrawer) {
                    openTertiaryDrawer(trigger.dataset.openTertiaryDrawer, secondaryDrawer);
                } else if (secondaryDrawer) {
                    closeTertiaryDrawers(secondaryDrawer);
                }
            });
        });

        // Add mouseover listener to primary nav to close drawers when hovering non-trigger elements
        const primaryNavColumn = offCanvasMenuDesktop.querySelector('.pt-20, .lg\\:pt-24');
        if (primaryNavColumn) {
            primaryNavColumn.addEventListener('mouseover', (e) => {
                const isOverSecondaryTrigger = e.target.closest('[data-open-secondary-drawer]');
                const isOverSecondaryDrawer = e.target.closest('[data-secondary-drawer]');

                if (!isOverSecondaryTrigger && !isOverSecondaryDrawer) {
                    closeAllDrawers();
                }
            });
        }

        // Add mouseleave listener to close all drawers when leaving the primary nav area
        offCanvasMenuDesktop.addEventListener('mouseleave', closeAllDrawers);

        // Add listeners to secondary drawers to manage tertiary drawers
        const secondaryDrawers = offCanvasMenuDesktop.querySelectorAll('[data-secondary-drawer]');
        secondaryDrawers.forEach(secondaryDrawer => {
            // Close tertiary drawers when hovering non-trigger elements
            secondaryDrawer.addEventListener('mouseover', (e) => {
                const isOverTertiaryTrigger = e.target.closest('[data-open-tertiary-drawer]');
                const isOverTertiaryDrawer = e.target.closest('[data-tertiary-drawer]');

                if (!isOverTertiaryTrigger && !isOverTertiaryDrawer) {
                    closeTertiaryDrawers(secondaryDrawer);
                }
            });

            // Close tertiary drawers when leaving the secondary drawer
            secondaryDrawer.addEventListener('mouseleave', (e) => {
                if (!e.relatedTarget || !secondaryDrawer.contains(e.relatedTarget)) {
                    closeTertiaryDrawers(secondaryDrawer);
                }
            });
        });

        window.addEventListener('click', (event) => {
            const openButtons = offCanvasMenuDesktop.querySelectorAll('[data-open-secondary-drawer],[data-open-tertiary-drawer]');
            const target = event.target;
            const secondaryDrawer = target.closest('[data-secondary-drawer]');

            // Handle secondary drawer toggle
            if (target.closest('[data-open-secondary-drawer]') &&  target.closest('[data-open-secondary-drawer]')?.querySelector('button')?.contains(target)) {
                const targetStatusContainer = target.closest('[data-open-secondary-drawer]');
                const drawerIndex = targetStatusContainer.dataset.openSecondaryDrawer;
                const targetDrawer = offCanvasMenuDesktop.querySelector(`[data-secondary-drawer="${drawerIndex}"]`);

                if (targetDrawer) {
                    for (const openButton of openButtons) {
                        openButton.dataset.open = 'false';
                    }

                    const isOpen = targetDrawer.dataset.visible === 'true';

                    // Close all secondary drawers
                    offCanvasMenuDesktop.querySelectorAll('[data-secondary-drawer]').forEach(drawer => {
                        drawer.dataset.visible = 'false';
                    });

                    // Toggle this one
                    targetDrawer.dataset.visible = isOpen ? 'false' : 'true';
                    targetStatusContainer.dataset.open = isOpen ? 'false' : 'true'
                    offCanvasMenuDesktop.dataset.secondaryDrawerOpen = isOpen ? 'false' : 'true';

                    // Always close tertiary drawers
                    offCanvasMenuDesktop.querySelectorAll('[data-tertiary-drawer]').forEach(drawer => {
                        drawer.dataset.visible = 'false';
                    });
                    offCanvasMenuDesktop.dataset.tertiaryDrawerOpen = 'false';
                }
            }

            // Handle tertiary drawer toggle
            if (target.closest('[data-open-tertiary-drawer]') && target.closest('[data-open-tertiary-drawer]')?.querySelector('button')?.contains(target)) {
                const targetStatusContainer = target.closest('[data-open-tertiary-drawer]');
                const drawerIndex = targetStatusContainer.dataset.openTertiaryDrawer;
                const targetDrawer = secondaryDrawer.querySelector(`[data-tertiary-drawer="${drawerIndex}"]`);

                if (targetDrawer) {
                    offCanvasMenuDesktop.querySelectorAll('[data-open-tertiary-drawer]').forEach(btn => {
                        btn.dataset.open = 'false';
                    });

                    const isOpen = targetDrawer.dataset.visible === 'true';

                    // Close all tertiary drawers
                    offCanvasMenuDesktop.querySelectorAll('[data-tertiary-drawer]').forEach(drawer => {
                        drawer.dataset.visible = 'false';
                    });

                    // Toggle this one
                    targetDrawer.dataset.visible = isOpen ? 'false' : 'true';
                    targetStatusContainer.dataset.open = isOpen ? 'false' : 'true'
                    offCanvasMenuDesktop.dataset.tertiaryDrawerOpen = isOpen ? 'false' : 'true';
                }
            }

            if (target.matches('[data-close-desktop-nav]') || target.parentElement?.matches('[data-close-desktop-nav]')) {
                closeDesktopNav();
            }
        });
    }


});